import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import {
    CircularProgress,
    Container,
    createTheme,
    ThemeProvider,
} from '@mui/material';

const HomePage = lazy(async () => {
    const { default: Home } = await import('../pages/home');
    return { default: Home };
});

const renderStack = () => (
    <Routes>
        <Route path="/" element={<HomePage />} />
    </Routes>
);

const theme = createTheme({
    typography: {
        fontFamily: ['Montserrat', 'sans-serif'].join(','),
    },
    palette: {
        primary: {
            light: '#757ce8',
            main: '#1b75bc',
            dark: '#002884',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#ffffff',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});

function Navigation(): JSX.Element {
    return (
        <Suspense
            fallback={(
                <Container>
                    <CircularProgress />
                </Container>
            )}
        >
            <ThemeProvider theme={theme}>{renderStack()}</ThemeProvider>
        </Suspense>
    );
}

export default Navigation;
